import React, { useMemo } from 'react'

import { useMediaQuery, useTheme } from '@mui/material'

import Desktop from './desktop'
import Mobile from './mobile'

import { DashboardFilter } from 'types/GlobalDashboardFilter'
import { ChipProps } from 'components_new/atoms/Chip'

export interface FilterBarProps {
  filter: DashboardFilter
  orientation?: 'horizontal' | 'vertical'
  resetUserInput?: () => void
  readOnly?: boolean
  setFilter?: (newDashboardFilter: DashboardFilter) => void
  size?: ChipProps['size']
  sx?: object
}

const FilterBar = (props: FilterBarProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'), {
    noSsr: true
  })

  const component = useMemo(
    () => (isMobile ? <Mobile {...props} /> : <Desktop {...props} />),
    [isMobile, props]
  )

  // success
  return component
}

export default FilterBar
